import { isRecord, type RecordOf } from 'immutable';

/** Narrows a value that is either a plain object or its Immutable Record form. */
export const isRecordOf = <T extends object>(value: RecordOf<T> | T | null | undefined): value is RecordOf<T> =>
  isRecord(value);
